import {
  isSatelliteAnomalyDataEnabled,
  isSatelliteBaselineDataEnabled,
  isSatelliteMSAVIDataEnabled,
  isSatelliteSecondaryLayersEnabled,
} from "../../../util/featureFlags";
import { SatelliteImageryDatatype } from "./types";

export const SATELLITE_IMAGERY_DATATYPES: SatelliteImageryDatatype[] = [
  {
    name: "NDVI (All-season growth)",
    id: "ndvi",
  },
];

if (isSatelliteBaselineDataEnabled) {
  SATELLITE_IMAGERY_DATATYPES.push({
    name: "5-year baseline (NDVI)",
    id: "baseline_ndvi",
  });
}

if (isSatelliteSecondaryLayersEnabled) {
  SATELLITE_IMAGERY_DATATYPES.push(
    {
      name: "EVI (Hazy conditions)",
      id: "evi",
    },
    {
      name: "NDRE (Mid-to-late season monitoring)",
      id: "ndre",
    },
    {
      name: "CCCI (Plant health and nitrogen needs)",
      id: "ccci",
    },
  );
}

if (isSatelliteMSAVIDataEnabled) {
  SATELLITE_IMAGERY_DATATYPES.push({
    name: "MSAVI (Early season monitoring)",
    id: "msavi",
  });
}

if (isSatelliteAnomalyDataEnabled) {
  SATELLITE_IMAGERY_DATATYPES.push({
    name: "Crop growth anomaly (NDVI)",
    id: "ndvi_anomaly",
  });
}
